import { render, staticRenderFns } from "./OnBoardingHomeCard.vue?vue&type=template&id=077e6f1c&"
import script from "./OnBoardingHomeCard.vue?vue&type=script&lang=ts&"
export * from "./OnBoardingHomeCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports